import styled from "styled-components";
import { Flex } from "rebass";

export const Banner = styled(Flex)`
  background-color: #608341;
  width: 100%;
  color: white;
  padding: 32px;
`;

export const Title = styled.h3`
  color: white;
  font-family: "Palatino Linotype", "Book Antiqua", Palatino, serif;
  font-size: 32px;
  margin: 0;
`;

export const Anchor = styled.a`
  color: white;
  font-family: "Trebuchet MS", Helvetica, sans-serif;
  text-decoration: none;
  :hover {
    text-decoration: underline;
  }
  :visited {
    color: white;
  }
`;

export const Paragraph = styled.p`
  color: white;
  font-family: "Trebuchet MS", Helvetica, sans-serif;
  text-align: center;
`;
